import { Component } from 'react';
import PropTypes from 'prop-types';
import { PhotoForTrailOrTrack } from '../../../application/javascripts/react_components/photos/photo_for_trail_or_track';
import Lightbox from '../../shared/Lightbox';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { formatImagesForLightbox } from '../../../utils/lightbox_helpers';
import { PhotoSize } from '@alltrails/shared/types/photos';
import { getPhotoUrl } from '@alltrails/shared/utils/requests/photoRequests';
import CustomProvider from 'components/CustomProvider';

class PhotoForTrailOrTrackCollection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lightboxOpen: false,
      activeIndex: null,
      lightboxPhotos: []
    };
  }

  formatDefaultPhoto(photo) {
    const { id, photoHash } = photo;
    return { id, url: getPhotoUrl({ id, photoHash }, PhotoSize.ExtraLarge) };
  }

  handleCloseRequest = () => {
    this.setState({ lightboxOpen: false });
  };

  handleSuccessCallback = (res, activeIndex) => {
    let lightboxPhotos = res.photos.map(p => p.photo);

    if (lightboxPhotos.length === 0) {
      const photo = this.formatDefaultPhoto(this.props.photos[activeIndex]);
      lightboxPhotos = [photo];
    }

    this.setState({ lightboxOpen: true, lightboxPhotos, activeIndex });
  };

  handleErrorCallback(err) {
    console.log(err);
  }

  openLightbox = index => {
    const url = this.props.photos[index].imageLink;
    ServerCommunicationUtil.getApiEndpoint(
      url,
      {},
      res => this.handleSuccessCallback(res, index),
      this.handleErrorCallback,
      () => {},
      {},
      'json'
    );
  };

  getLightboxProps() {
    const images = formatImagesForLightbox(this.state.lightboxPhotos);
    const currentImage = this.props.photos[this.state.activeIndex];

    return {
      isOpen: this.state.lightboxOpen,
      images: images,
      handleCloseRequest: this.handleCloseRequest,
      startingIndex: 0, // since these images are being requested they will alway start at index 0
      trailId: currentImage.trailId,
      mapId: currentImage.mapId
    };
  }

  //renders

  renderPhotos() {
    return this.props.photos.map((photo, index) => {
      return (
        <PhotoForTrailOrTrack
          key={photo.photoId}
          photo={photo}
          index={index}
          openLightbox={this.openLightbox}
          languageRegionCode={this.props.context.languageRegionCode}
        />
      );
    });
  }

  renderLightbox() {
    if (!this.state.lightboxOpen) {
      return;
    }

    const lightboxProps = this.getLightboxProps();

    return <Lightbox key="lightbox" {...lightboxProps} />;
  }

  render() {
    return (
      <CustomProvider>
        {this.renderPhotos()}
        {this.renderLightbox()}
      </CustomProvider>
    );
  }
}

PhotoForTrailOrTrack.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      formattedCreatedAt: PropTypes.string,
      imageClass: PropTypes.string,
      imageLink: PropTypes.string,
      imageSrc: PropTypes.string,
      index: PropTypes.number,
      location: PropTypes.string,
      photoHash: PropTypes.string,
      photoId: PropTypes.number,
      text: PropTypes.string,
      textLink: PropTypes.string
    })
  )
};

export default PhotoForTrailOrTrackCollection;
